import { Customer } from './../../../shared/models/customer';
import { CartService } from './../../../shared/services/cart.service';
import { ImageService } from '../../../shared/services/image.service';
import { Article } from './../../../shared/models/article';
import { Component, OnInit, Input } from '@angular/core';
import { UserService } from './../../../shared/services/user.service';
import { ArticleService } from './../../../shared/services/article.service';
import { CustomerService } from 'src/app/shared/services/customer.service';

@Component({
    selector: 'app-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    providers: [ImageService, UserService, ArticleService],
    standalone: false
})
export class ProductCardComponent implements OnInit {
  @Input() product: Article;
	@Input() isWholesaler: boolean;

  constructor(
		private cartService: CartService,
		private uploadFileService: ImageService,
		private userService: UserService,
		private articleService: ArticleService
  ) { }

  ngOnInit(): void {
  }

  // Add to cart
	public addToCart(product: Article, quantity: number = 1) {
		this.cartService.addToCart(product, quantity);
	}

	// arma url de la photo del articulo
	getUrl = (photos: string) => {
		return this.uploadFileService.getUrlFirstElement(photos);
	}

  // metodo que para obtener el precio correspondiente al cliente logueado
	getPrice(p: Article) {
		const customer: Customer = this.userService.getIdentity();
		if (customer) {
			return this.articleService.getPrice(p, customer.listPrice);
		} else {
			return p.unitPrice;
		}
	}

	validatePrice(p: Article) {
		return this.getPrice(p) > 0;
	}

	isAvailable(p: Article): boolean {
	  if(this.isWholesaler || (!this.isWholesaler && p.unitInStock > 0)){
			return true;
		}
		else {
			return false;
		}
	}
}
